/**
 * Restricts uploads to allowed image formats and files <= 5MB.
 * Allowed formats: JPEG, GIF, PNG, AVIF, BMP, WebP, TIFF, JPEG 2000, HEIC.
 */
export const ALLOWED_IMAGE_TYPES: readonly string[] = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/avif',
  'image/bmp',
  'image/webp',
  'image/tiff',
  'image/jp2', // JPEG 2000
  'image/heic',
  'image/heif', // Some browsers use this for HEIC/HEIF
]

export const MAX_IMAGE_SIZE_MB = 5
